import * as React from "react";
import { action } from "mobx";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { EducationExperience } from "../../../models/profile";
import { Grid, Row, Col } from "react-flexbox-grid";
import ResumeNavBtns from "../resumeNavBtns";
import { IAddEducationLocalization, IResumeLocalization, IOption, IBoolOption, ILocalization } from "../../../models/localization";
import { ParsedResumeResults } from "../../../models/parsedResumeResults";
import { LookupValue } from "../../../models/lookup";
import { LookupType } from "../../../models/enums";
import TextField from "material-ui/TextField";
import CheckBox from "material-ui/Checkbox";
import Select from "material-ui/Select"
import { MenuItem } from "material-ui/Menu";
import { FormControl, FormControlLabel } from "material-ui/Form";
import { InputLabel } from "material-ui/Input";
import { MMYYPicker, MMYYRangePicker, MMYYPickValue } from "../../widgets/mmyyPicker";
import DescriptionEditor from "../descriptionEditor";
import ReferenceEditor, { RefField } from "../referenceEditor";
import { ValidatorForm, SelectValidator } from "react-material-ui-form-validator";
import * as s from "./educationExperience.css";

@observer
class SchoolEditor extends React.Component<{ store: SeekerStore, exp: EducationExperience, fromResume: boolean }, {}> {
  constructor(props: any) {
    super(props);
    this.props.store.profileStore.setDegreeSelected(false);
  }

  @action componentWillUnmount() {
    this.props.store.profileStore.setDegreeSelected(true);
  }

  @action onChangeReference = (val: string, fmt: RefField): void => {
    switch (fmt) {
      case RefField.Name:
        this.props.exp.refName = val;
        break;
      case RefField.Title:
        this.props.exp.refTitle = val;
        break;
      case RefField.Phone:
        this.props.exp.refPhone = val;
        break;
      case RefField.Contact:
        this.props.exp.refContact = val;
        break;
    }
  }
  @action onChangeMMYY = (val: number, fmt: MMYYPickValue): void => {
    switch (fmt) {
      case MMYYPickValue.FromMon:
        this.props.exp.fromMon = val;
        break;
      case MMYYPickValue.FromYear:
        this.props.exp.fromYear = val;
        break;
      case MMYYPickValue.ToMon:
        this.props.exp.toMon = val;
        break;
      case MMYYPickValue.ToYear:
        this.props.exp.toYear = val;
        break;
      case MMYYPickValue.Current:
        this.props.exp.active = val === 1;
        break;
    }
  }
  @action changeProperty = (e: any): void => {
    const key: string = e.target.id || e.target.name;
    if (key) {
      this.props.exp[key] = e.target.value;
    }
    if (key === "degTypeId" && e.target.value > 0) {
      this.props.store.profileStore.setDegreeSelected(true);
    }
  }
  @action onSetGraduated = (chk: boolean): void => {
    this.props.exp.grad = chk;
  }
  getMenuItems(type: LookupType, text: string, val: string): JSX.Element[] {
    let menus: JSX.Element[] = [];
    this.props.store.localization.getLookup(type).map((lv: LookupValue, i: number): void => {
      menus.push(<MenuItem key={i} value={lv[val]}>{lv[text]}</MenuItem>);
    });
    return menus;
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const addEd: IAddEducationLocalization = this.props.store.localization.fields.addEducation;
    const resumeLocal: IResumeLocalization = this.props.store.localization.fields.resume;
    const checked: any = { color: "#5B6770" };

    if (this.props.exp.degTypeId  > 0) {
      this.props.store.profileStore.setDegreeSelected(true);
    }

    return (
      <div>
        {this.props.fromResume && <Row className={s.checkBoxRow}>
          <Col xs={12}>
            <FormControlLabel label={resumeLocal.addToProfile} control={<CheckBox style={checked} checked={this.props.store.profileStore.srcIncluded("ed")}
              onChange={(e: object, chk: boolean) => this.props.store.profileStore.setSelected("ed", chk)} />} />
          </Col>
        </Row>}
        <Row>
          <Col xs={12} sm={6} xl={5} className={s.col}>
            <TextField id="name" label={addEd.name} value={this.props.exp.name} onChange={this.changeProperty} fullWidth />
          </Col>
          <Col xs={12} sm={6} xlOffset={1} xl={5} className={s.col}>
            <FormControl fullWidth>
              <InputLabel htmlFor="degTypeId" style={{color: "red"}}>{addEd.degree} *{local.required}</InputLabel>
              <Select
                value={this.props.exp.degTypeId}
                onChange={this.changeProperty}
                inputProps={{ name: "degTypeId", id: "degTypeId" }}>
                {this.getMenuItems(LookupType.EducationLevel, "value", "order")}
              </Select>
            </FormControl>
          </Col>
        </Row>
        <Row className={s.row}>
          <Col xs={12} sm={6} xl={5}>
            <MMYYRangePicker store={this.props.store} title={addEd.attended} fromLabel={addEd.attendFrom} toLabel={addEd.attendTo} fwd={false}
              currentLabel={addEd.active} current={this.props.exp.active} fromMon={this.props.exp.fromMon} fromYr={this.props.exp.fromYear} toMon={this.props.exp.toMon} toYr={this.props.exp.toYear}
              onChange={this.onChangeMMYY} />
          </Col>
          <Col xs={12} sm={6} xlOffset={1} xl={5} className={s.col}>
            <TextField id="major" value={this.props.exp.major} label={addEd.major} onChange={this.changeProperty} fullWidth /><br />
            <TextField id="minor" value={this.props.exp.minor} label={addEd.minor} onChange={this.changeProperty} fullWidth />
            <Row className={s.row}>
              <Col xs={6} xl={5} className={s.col}>
                <TextField id="gpa" label={addEd.gpa}
                  InputProps={{ inputProps: { min: 0, max: 5, step: 0.1 } }}
                  type="number" value={this.props.exp.gpa} onChange={this.changeProperty} />
              </Col>
              <Col xs={6} className={s.col}>
                <FormControlLabel label={addEd.graduated} control={<CheckBox style={checked} checked={this.props.exp.grad} onChange={(e: any, chk: boolean) => this.onSetGraduated(chk)} />} />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className={s.row}>
          <Col xs={12} sm={12} md={6} lg={6} xl={5}>
            <ReferenceEditor store={this.props.store} reference={this.props.exp} onChange={this.onChangeReference} />
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xlOffset={1} xl={5}>
            <DescriptionEditor store={this.props.store} descriptor={this.props.exp} subHeading=" " />
          </Col>
        </Row>
      </div>
    );
  }
}

@observer
class CourseEditor extends React.Component<{ store: SeekerStore, exp: EducationExperience, fromResume: boolean }, {}> {
  constructor(props: any) {
    super(props);
  }
  @action onChangeProperty = (e: any): void => {
    this.props.exp[e.target.name] = e.target.value;

  }
  @action onChangeMMYY = (val: number, fmt: MMYYPickValue): void => {
    switch (fmt) {
      case MMYYPickValue.ToMon:
        this.props.exp.toMon = val;
        break;
      case MMYYPickValue.ToYear:
        this.props.exp.toYear = val;
        break;
      case MMYYPickValue.Current:
        this.props.exp.active = val === 1;
        break;
    }
  }
  getMenuItems(levels: IOption[], label: string): JSX.Element[] {
    const items: JSX.Element[] = [];
    items.push(<MenuItem key="no-sel" value={0}>{label}</MenuItem>);
    levels.map((lvl: IOption, i: number): void => {
      items.push(<MenuItem key={i} value={lvl.value}>{lvl.text}</MenuItem>);
    });
    return items;
  }
  getBoolItems(levels: IBoolOption[], label: string): JSX.Element[] {
    const items: JSX.Element[] = [];
    items.push(<MenuItem key="no-sel" value={0}>{label}</MenuItem>);
    levels.map((lvl: IBoolOption, i: number): void => {
      items.push(<MenuItem key={i} value={lvl.value.toString()}>{lvl.text}</MenuItem>);
    });
    return items;
  }
  render(): JSX.Element {
    const addEd: IAddEducationLocalization = this.props.store.localization.fields.addEducation;
    const resumeLocal: IResumeLocalization = this.props.store.localization.fields.resume;
    const checked: any = { color: "#5B6770" };

    return (<div>
      <Row>
        <Col xs={12} sm={6} md={5} xl={4}>
          <FormControl fullWidth>
            <InputLabel htmlFor="level">{resumeLocal.level}</InputLabel>
            <Select value={this.props.exp.level} onChange={this.onChangeProperty} inputProps={{ name: "level", id: "level" }}>
              {this.getMenuItems(addEd.level, this.props.store.localization.fields.select)}
            </Select>
          </FormControl>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={6} md={5} xl={4} className={s.col}>
          <TextField label={resumeLocal.courseTitle} value={this.props.exp.courseTitle} onChange={this.onChangeProperty} name="courseTitle" fullWidth />
        </Col>
        <Col xs={12} sm={6} md={5} xlOffset={1} xl={4} className={s.col}>
          <TextField label={resumeLocal.provider} value={this.props.exp.name} onChange={this.onChangeProperty} name="name" fullWidth />
        </Col>
      </Row>
      <Row>
        <Col xs={8} sm={6} className={s.col}>
          <MMYYPicker store={this.props.store} title={addEd.completed} mon={this.props.exp.toMon} yr={this.props.exp.toYear} fwd={false} onChange={this.onChangeMMYY}
            currentLabel={addEd.active} current={this.props.exp.active} />
        </Col>
      </Row>
      <Row className={s.row}>
        <Col xs={6} sm={4} md={3} xl={4}className={s.col}>
          <FormControl fullWidth>
            <InputLabel htmlFor="forCredit">{addEd.credit}</InputLabel>
            <Select value={this.props.exp.forCredit.toString()} onChange={this.onChangeProperty} inputProps={{ name: "forCredit", id: "forCredit" }}>
              {this.getBoolItems(addEd.credittypes, this.props.store.localization.fields.select)}
            </Select>
          </FormControl>
        </Col>
        <Col xs={6} sm={4} md={3} xlOffset={1} xl={3} >
          {this.props.exp.forCredit && <FormControl fullWidth>
            <InputLabel htmlFor="grade">{addEd.grade}</InputLabel>
            <Select value={this.props.exp.grade} onChange={this.onChangeProperty} inputProps={{ name: "grade", id: "grade" }}>
              {this.getMenuItems(addEd.grades, this.props.store.localization.fields.select)}
            </Select>
          </FormControl>}
          {!this.props.exp.forCredit && <FormControl fullWidth>
            <InputLabel htmlFor="grade">{addEd.grade}</InputLabel>
            <Select value={this.props.exp.grade} onChange={this.onChangeProperty} inputProps={{ name: "grade", id: "grade" }}>
              {this.getMenuItems(addEd.passfail, this.props.store.localization.fields.select)}
            </Select>
          </FormControl>}
        </Col>
      </Row>
    </div>);
  }
}

@inject("store") @observer
export default class EducationExperienceEditor extends React.Component<{ store: SeekerStore, exp: EducationExperience, fromResume: boolean }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    return (
      <div>
        {this.props.exp.edType === 1 && <SchoolEditor store={this.props.store} exp={this.props.exp} fromResume={this.props.fromResume} />}
        {this.props.exp.edType === 2 && <CourseEditor store={this.props.store} exp={this.props.exp} fromResume={this.props.fromResume} />}
        {this.props.fromResume && <ResumeNavBtns store={this.props.store} />}
      </div>);
  }
}


// WEBPACK FOOTER //
// ./src/components/profile/educationExperienceEditor/index.tsx